'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';


$(document).ready(function(){
	if (!$("#popup_window").length) { // init if not in dialog view
		dinamicSubmenuTop();
	}
});

function dinamicSubmenuTop() {
	var $dinamicSubmenu = $('.has-sm-t-d');
	
	if ($dinamicSubmenu.length > 0 && $('.s--measures').length > 0 && $('.header__b').length > 0) {
		this.$measures = $('.s--measures');
		this.$header = $('.header');
		this.$headerBottom = $('.header__b');
		
		this.$headerHeight = this.$header.height();
		this.$measuresOffset = this.$measures.offset();
		this.$measuresHeight = this.$measures.height();
		this.$windowWidth = $(window).outerWidth(true);
		
		var self = this;
		
		this.updateValues = function(){
			self.$headerHeight = $header.height();
			self.$measuresOffset = $measures.offset();
			self.$measuresHeight = $measures.height();
			self.$windowWidth = $(window).outerWidth(true);
		};
		
		this.calcDistance = function(){
			if ($(window).scrollTop() + self.$headerHeight > self.$measuresOffset.top + self.$measuresHeight) {
				self.$headerBottom.addClass('visible');
			}
			else{
				self.$headerBottom.removeClass('visible');
			}
		};
		
		setTimeout(function(){
			self.updateValues();
			if (self.$windowWidth > 991) {
				self.calcDistance();
			}
		}, 50);
		
		window.onscroll = function(){
			if (self.$windowWidth > 991) {
				self.calcDistance();
			}
		};
		window.onresize = function(){
			self.updateValues();
			if (self.$windowWidth > 991) {
				self.calcDistance();
			}
		};
	}
}

function blocks_diagram(){
	
}

EwSiteApp.controller("MixedCtrl", function($scope, $element, $attrs){
	var type = "bar";
	
	var data = {
		labels: ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		datasets: [{
			label: 'Kiti įsipareigojimai',
			data: ["10","20","30","40","30","60","50"],
			backgroundColor: "#033878",
			borderColor: "#033878",
			order: 1
		}, {
			label: 'Ateinančių laikotarpių garantijų atlyginimo pajamos',
			data: ["9","18","12","37","5","21","55"],
			backgroundColor: "#d23046",
			borderColor: "#d23046",
			type: 'line',
			order: 0
		}]
	};

	var options = {
		responsive: true,
		plugins: {
			htmlLegend: {
				// ID of the container to put the legend in
				containerID: 'chart_'+$attrs.chartId+'_legend',
			},
			legend: {
				display: false,
			},
			tooltip: customChartJsTooltip
		},
		elements: {
			point: {
				radius: 6,
				hoverRadius: 8
			}
		},
		datasets: {
			bar: {
				barPercentage: 0.9,
				borderWidth: 0,
				borderRadius: 4,
				borderSkipped: false,
				maxBarThickness: 34
			}
		},
		scales: {
			x: {
				offset: true,
				grid: {
					display: true,
					drawBorder: true,
					drawOnChartArea: false,
					drawTicks: true,
					borderWidth: 2,
					borderColor: '#033878',
					tickColor: '#033878',
					tickLength: 8,
					tickWidth: 2,
					offset: false,
				},
				ticks: {
					color: '#033878',
					font: {
						family: "'Barlow', 'Arial', sans-serif",
						size: 13,
						weight: 'bold',

					}
				}
			},
			y: {
				offset: true,
				grid: {
					display: true,
					drawBorder: false,
					drawOnChartArea: false,
					drawTicks: false,
					borderWidth: 2,
					borderColor: '#033878',
					tickColor: '#033878',
					tickLength: 8,
					tickWidth: 2,
					offset: false,
				},
				ticks: {
					color: '#033878',
					font: {
						family: "'Barlow', 'Arial', sans-serif",
						size: 13,
						weight: 'normal',

					}
				}
			}
		}
	};

	var config = {
		type: type,
		data: data,
		options: options,
		plugins: [htmlLegendPlugin]
	};

	var chart = new Chart($element, config);
});

EwSiteApp.controller("BarCtrl", function($scope, $element, $attrs){
	var type = "bar";
	
	var data = {
		labels: ["2020", "2021", "2022"],
		datasets: [{
				label: 'Kiti įsipareigojimai',
				data: ["20", "38", "8"],
				backgroundColor: "#033878",
				hoverBackgroundColor: "#033878",
			}, {
				label: 'Ateinančių laikotarpių garantijų atlyginimo pajamos',
				data: ["10", "23", "23"],
				backgroundColor: "#d54f2e",
				hoverBackgroundColor: "#d54f2e",
			}, {
				label: 'Atidėjimai',
				data: ["47", "17", "58"],
				backgroundColor: "#d23046",
				hoverBackgroundColor: "#d23046",
			}, {
				label: 'Nuosavybė',
				data: ["38", "68", "10"],
				backgroundColor: "#3277bd",
				hoverBackgroundColor: "#3277bd",
			}]
	};

	var options = {
		indexAxis: 'y',
		responsive: true,
		plugins: {
			htmlLegend: {
				// ID of the container to put the legend in
				containerID: 'chart_'+$attrs.chartId+'_legend',
			},
			legend: {
				display: false,
			},
			tooltip: customChartJsTooltip
		},
		datasets: {
			bar: {
				barPercentage: 0.9,
				borderWidth: 0,
				borderRadius: 4,
				borderSkipped: false,
			}
		},
		scales: {
			x: {
				offset: true,
				grid: {
					display: true,
					drawBorder: false,
					drawOnChartArea: false,
					drawTicks: true,
					borderWidth: 2,
					borderColor: '#033878',
					tickColor: '#033878',
					tickLength: 16,
					tickWidth: 1,
					offset: false,
				},
				ticks: {
					color: '#033878',
					font: {
						family: "'Barlow', 'Arial', sans-serif",
						size: 13,
						weight: 'normal',

					}
				}
			},
			y: {
				grid: {
					display: true,
					drawBorder: true,
					drawOnChartArea: false,
					drawTicks: true,
					borderWidth: 3,
					borderColor: '#033878',
					tickColor: '#033878',
					tickLength: 8,
					tickWidth: 2,
					offset: false,
				},
				ticks: {
					color: '#033878',
					font: {
						family: "'Barlow', 'Arial', sans-serif",
						size: 13,
						weight: 'bold',

					}
				}
			}
		}
	};

	var config = {
		type: type,
		data: data,
		options: options,
		plugins: [htmlLegendPlugin]
	};

	var chart = new Chart($element, config);
});

EwSiteApp.controller("LineCtrl", function($scope, $element, $attrs){

	var type = 'line';

	var data = {
		labels: ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
		datasets: [{
			label: 'Kiti įsipareigojimai',
			data: ["20", "38", "8", "58", "85", "85", "118"],
			backgroundColor: "#033878",
			borderColor: "#033878",
		}, {
			label: 'Ateinančių laikotarpių garantijų atlyginimo pajamos',
			data: ["10", "23", "23", "88", "102", "102", "107"],
			backgroundColor: "#d54f2e",
			borderColor: "#d54f2e",
		}, {
			label: 'Atidėjimai',
			data: ["47", "17", "58", "44", "112", "130", "130"],
			backgroundColor: "#d23046",
			borderColor: "#d23046",
		}, {
			label: 'Nuosavybė',
			data: ["38", "68", "-10", "75", "75", "75", "140"],
			backgroundColor: "#3277bd",
			borderColor: "#3277bd",
		}]
	};

	var options = {
		responsive: true,
		plugins: {
			htmlLegend: {
				// ID of the container to put the legend in
				containerID: 'chart_'+$attrs.chartId+'_legend',
			},
			legend: {
				display: false,
			},
			tooltip: customChartJsTooltip
		},
		interaction: {
			intersect: false,
			mode: 'index'
		},
		elements: {
			point: {
				radius: 4,
				hoverRadius: 6
			},
			line: {
				borderWidth: 2,
				tension: 0.3,
				fill: false,
			}
		},
		scales: {
			x: {
				offset: true,
				grid: {
					display: true,
					drawBorder: true,
					drawOnChartArea: false,
					drawTicks: true,
					borderWidth: 2,
					borderColor: '#033878',
					tickColor: '#033878',
					tickLength: 8,
					tickWidth: 2,
				},
				ticks: {
					color: '#033878',
					font: {
						family: "'Barlow', 'Arial', sans-serif",
						size: 13,
						weight: 'bold',

					}
				}
			},
			y: {
				offset: true,
				grid: {
					display: true,
					drawBorder: true,
					drawOnChartArea: false,
					drawTicks: true,
					borderWidth: 3,
					borderColor: '#033878',
					tickColor: '#033878',
					tickLength: 16,
					tickWidth: 2,
				},
				ticks: {
					color: '#033878',
					font: {
						family: "'Barlow', 'Arial', sans-serif",
						size: 13,
						weight: 'normal',

					}
				}
			}
		}
	};

	var config = {
		type: type,
		data: data,
		options: options,
		plugins: [htmlLegendPlugin],
	};
			
	var chart = new Chart($element, config);
});

EwSiteApp.controller("DoughnutCtrl", function($scope, $element, $attrs){
	var type = 'doughnut';

	var data = {
		labels: ['Kiti įsipareigojimai', 'Ateinančių laikotarpių garantijų atlyginimo pajamos', 'Atidėjimai', 'Nuosavybė'],
		datasets: [{
			label: 'Lorem',
			data: ["20","25","33","22"],
			backgroundColor: ['#033878','#d54f2e','#d23046','#3277bd'],
			borderWidth: 4,
			hoverBorderColor: '#ffffff',
		}]
	};

	var options = {
		cutout: '68%',
		responsive: true,
		plugins: {
			htmlLegend: {
				// ID of the container to put the legend in
				containerID: 'chart_'+$attrs.chartId+'_legend',
			},
			legend: {
				display: false,
			},
			tooltip: customChartJsTooltip
		}
	};

	var config = {
		type: type,
		data: data,
		options: options,
		plugins: [htmlLegendPlugin],
	};
	
	var chart = new Chart($element, config);
});

EwSiteApp.controller("PieCtrl", function($scope, $element, $attrs){
	var type = 'pie';

	var data = {
		labels: ['Kiti įsipareigojimai', 'Ateinančių laikotarpių garantijų atlyginimo pajamos', 'Atidėjimai', 'Nuosavybė'],
		datasets: [{
			label: 'Lorem',
			data: ["20","25","33","22"],
			backgroundColor: ['#033878','#d54f2e','#d23046','#3277bd'],
			borderWidth: 0,
			hoverBorderColor: '#ffffff',
		}]
	};

	var options = {
		responsive: true,
		plugins: {
			htmlLegend: {
				// ID of the container to put the legend in
				containerID: 'chart_'+$attrs.chartId+'_legend',
			},
			legend: {
				display: false,
			},
			tooltip: customChartJsTooltip
		}
	};

	var config = {
		type: type,
		data: data,
		options: options,
		plugins: [htmlLegendPlugin],
	};

	var myChart = new Chart($element, config);
});